import React from "react";

export const isReactComponent = (component: any) => {
  return (component instanceof React.Component) ||
    // Check for class components
    (typeof component === 'function' && !!component?.prototype?.isReactComponent) ||
    // Check for function components (no reliable way to confirm without executing them)
    (typeof component === 'function' && !component?.prototype?.isReactComponent) ||
    // Check for React component types like forwardRef or memo
    (typeof component === 'object' && (component?.$$typeof === React.forwardRef || component?.$$typeof === React.memo))
};

export type ValidComponent<TProps> =
    ((props?: TProps) => JSX.Element) |
    JSX.Element |
    (TProps & { Component: React.ComponentType<TProps> }) |
    React.Component;

export const isValidComponent = <TProps>(value: any): value is ValidComponent<TProps> => {
    // Check if it's a React component instance
    if (value instanceof React.Component) {
        return true;
    }

    // Check if it's a JSX element
    if (React.isValidElement(value)) {
        return true;
    }

    // Check if it's a functional component or a function that returns a JSX element
    if (typeof value === 'function') {
        // This assumes the function returns a JSX element which we can't verify at runtime
        // However, typically, if it's used as a component, it should return a JSX element or null.
        // More rigorous check might involve attempting to call it and catching errors, which is risky.
        return true;
    }

    // Check if it's an object with a Component property that is a React component type
    if (typeof value === 'object' && value !== null && 'Component' in value) {
        return typeof value.Component === 'function';
    }

    return false;
}
